import React from 'react';
import CopyToClipboardButton from '../../../components/CopyToClipboardButton';

export default function QuoteGridRow({ row, columns, expanded, onToggle, totalQuantity, grayOut, expandAll }) {
    const baseRowClasses = 'text-center border-b last:!border-none cursor-pointer transition-colors duration-100';

    const stateClasses = [expanded ? 'bg-blue-50' : 'bg-white', grayOut ? 'opacity-60' : '', 'hover:bg-blue-50']
        .filter(Boolean)
        .join(' ');

    return (
        <tr className={`${baseRowClasses} ${stateClasses}`} onClick={onToggle} style={{ userSelect: 'none' }}>
            {columns.map((col) => {
                if (col.key === 'partName') {
                    return (
                        <td key={col.key} className='px-4 py-3 text-left'>
                            <div className='flex gap-2 items-center'>
                                <span className='font-semibold tracking-tight'>{row.partName}</span>
                                <CopyToClipboardButton toCopy={row.partName} label='Part Number' />
                            </div>
                        </td>
                    );
                }

                if (col.key === 'quotes') {
                    return (
                        <td key={col.key} className='px-4 py-3 text-center'>
                            <span className='font-medium'>{row.quotes}</span>
                        </td>
                    );
                }

                if (col.key === 'quantityRequested') {
                    return (
                        <td key={col.key} className='px-4 py-3 text-center'>
                            <span className='font-medium tabular-nums'>{totalQuantity}</span>
                        </td>
                    );
                }

                if (col.key === 'processed') {
                    return (
                        <td key={col.key} className='px-4 py-3 text-center'>
                            {typeof row.processed === 'string' && row.processed.includes('/') ? (
                                <div
                                    className={`inline-flex justify-center items-center px-2 py-1 text-xs font-medium text-gray-800 bg-gray-100 rounded-full border border-gray-200`}
                                >
                                    <span className='tabular-nums'>{row.processed}</span>
                                </div>
                            ) : (
                                <div className='flex justify-center items-center w-full h-full'>
                                    <input type='checkbox' checked={!!row[col.key]} readOnly />
                                </div>
                            )}
                        </td>
                    );
                }

                if (col.key === 'customerContractPrice') {
                    return (
                        <td key={col.key} className='px-4 py-3 font-mono text-sm font-normal text-center'>
                            {row.customerContractPrice}
                        </td>
                    );
                }

                if (col.key === 'listPrice') {
                    return (
                        <td key={col.key} className='px-4 py-3 font-mono text-sm font-normal text-center'>
                            {row.listPrice}
                        </td>
                    );
                }

                return <td key={col.key} className='px-4 py-3 font-normal text-center'></td>;
            })}
        </tr>
    );
}
